<template>
  <div class="my-pooq-view-wrapper" data-scroll-element="true">
    <div v-if="device === 'mobile'" class="sticky-area">
      <common-header
        title="진행중인 이벤트"
        :is-back-btn="true"
        :back-fn="close"
        :is-close-btn="true"
        :close-fn="close"
      ></common-header>
    </div>
    <div
      v-if="!isEventDetailLoading"
      class="event-view-wrap"
      data-scroll-element="true"
    >
      <div class="event-view-tit">
        <strong class="event-tit">{{ eventTitle }}</strong>
        <p class="event-text">{{ startDate }} ~ {{ endDate }}</p>
      </div>
      <span v-if="contentData" class="content" v-html="contentData"> </span>
      <div v-else class="event-view-img">
        <img :src="getImage(eventPosterImage)" :alt="setAlt()" />
      </div>

      <EventContentList
        v-if="hasContentList && !isContentListLoading"
        :event-content-list="contentList"
        :content-type="contentType"
        @load-more="loadMore()"
      />
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { infiniteScroll } from '@/common/directives'
  import utils from '@/common/util/utils'
  import CommonHeader from '@/components/header/template/commonHeader'
  import { resizeThumbnail } from '@/common/image.filter'
  import EventContentList from '@/components/lnb/event/EventContentList'
  import { MOBILE_WEB_HOSTNAME } from '@/common/constant'
  import { isLogin } from '@/common/util/credential/is-login'
  import {
    postEventApply,
    getEventDetail,
    getEventContentList,
  } from '@/common/requests/data-fetch'

  export default {
    name: 'EventDetailView',
    components: { EventContentList, CommonHeader },
    directives: {
      infiniteScroll,
    },
    data() {
      return {
        eventId: '',
        eventDetailData: {},
        contentList: [],
        offset: 0,
        limit: 20,
        endOfList: true,
        device: utils.cookies.getDevice(),
        idDataLoading: false,
        isEventDetailLoading: true,
        isContentListLoading: true,
      }
    },
    computed: {
      isLoaded() {
        return (
          Object.keys(this.eventDetailData).length > 0 && this.hasContentList
        )
      },
      eventTitle() {
        return _.get(this.eventDetailData, 'eventTitle', '이벤트')
      },
      eventPosterImage() {
        return _.get(this.eventDetailData, 'detailImage', '')
      },
      startDate() {
        return _.get(this.eventDetailData, 'startDate', '')
      },
      endDate() {
        return _.get(this.eventDetailData, 'endDate', '')
      },
      contentData() {
        const { content } = this.eventDetailData
        return content?.replace(/www.wavve.com/gi, MOBILE_WEB_HOSTNAME)
      },
      hasContentList() {
        return this.contentList.length > 0
      },
    },
    watch: {
      contentData(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.bindAnchorClickEvents()
          })
        }
      },
    },
    created() {
      this.eventId = this.$route.params.eventid
      this.setData()
    },
    methods: {
      bindAnchorClickEvents() {
        const contentElement = document.querySelector('.content')
        if (!contentElement) {
          return
        }
        const anchorTags = contentElement.querySelectorAll('a')
        // NOTE: href가 "#action:"로 시작하는 경우: 앵커 태그 클릭 시 특정 액션 수행
        // #action: 뒤에 오는 값에 따라 다른 액션 수행
        // event-apply: 이벤트 응모하기
        anchorTags.forEach((anchor) => {
          const href = anchor.getAttribute('href')
          if (href && href.includes('#action:')) {
            anchor.setAttribute('href', '#')
            const action = href.split('#action:')[1]
            switch (action) {
              case 'event-apply':
                anchor.addEventListener('click', (event) => {
                  event.preventDefault()
                  this.eventApply()
                })
                break
            }
          }
        })
      },
      // 이벤트 응모하기
      async eventApply() {
        if (!isLogin()) {
          // TODO: 앱일때에도 isLogin이 true를 반환하는지 확인 필요
          this.$router.replace(`/member/login?referer=${this.$route.fullPath}`)
          return
        }
        const result = await postEventApply({
          eventId: this.eventId,
        })
        if (!result || result?.error) {
          const { status } = result?.error?.response || {}
          switch (status) {
            case 409:
              utils.alert('이미 응모하셨습니다.')
              return
            case 404:
              utils.alert('존재하지 않는 이벤트입니다.')
              return
            case 403:
              utils.alert('로그인 정보가 올바르지 않습니다.')
              return
            default:
              utils.alert('다시 시도해주세요.')
          }
          return
        }
        utils.alert('응모되었습니다!')
      },
      getImage(img) {
        return resizeThumbnail(img, {
          width: 0,
          height: 0,
          option: '20',
          quality: 80,
        })
      },
      setAlt() {
        const {
          eventtitle = '',
          description = '',
          startdate = '',
          enddate = '',
          gift = '',
          announcementdate = '',
        } = this.eventDetailData
        const defaultAlt =
          eventtitle &&
          description &&
          startdate &&
          enddate &&
          gift &&
          announcementdate
            ? `${eventtitle} ${description} 기간은 ${startdate}부터 ${enddate}까지 입니다.`
            : ''
        const giftAlt =
          gift === ''
            ? ''
            : ` 이벤트 경품은 ${gift}입니다. 당첨자 발표일은 ${announcementdate}입니다.`
        return defaultAlt + giftAlt
      },
      loadMore() {
        if (this.endOfList) {
          this.isContentListLoading = false
          return
        }
        if (this.idDataLoading) return
        this.setEventContentList()
      },
      setData() {
        this.isEventDetailLoading = true

        getEventDetail({ eventId: this.eventId }).then(({ data }) => {
          this.isEventDetailLoading = false
          this.eventDetailData = data
          this.endOfList = false
          this.setEventContentList()
        })
      },
      setEventContentList() {
        this.idDataLoading = true
        this.isContentListLoading = true
        getEventContentList({
          eventId: this.eventId,
          offset: this.offset,
          limit: this.limit,
        }).then(({ data: eventContents }) => {
          this.offset += this.limit

          const { list = [] } = eventContents

          this.contentList = [...this.contentList, ...list]
          this.endOfList = list.length === 0
          this.isContentListLoading = false
          this.idDataLoading = false
        })
      },
      close() {
        this.$router.back()
      },
    },
  }
</script>

<style scoped>
  .event-view-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    padding: 0 10px 10px 10px;
  }
  .displayNone + .my-wrap .my-pooq-view-wrapper .event-view-wrap {
    height: auto;
  }
  .event-view-wrap::-webkit-scrollbar {
    display: none;
  }
  .event-view-img img {
    width: 100%;
  }
  .event-view-tit {
    padding: 17px 0;
  }
  .event-view-tit .event-tit {
    padding: 0 0 5px;
  }
  .event-tit,
  .event-tit02 {
    display: block;
    color: #fff;
  }
  .event-tit {
    padding: 15px 10px 10px;
    font-size: 16px;
  }
  .event-view-tit .event-text {
    padding: 0;
  }
  .event-text {
    font-size: 12px;
    color: #a5a5a5;
    padding: 0 10px 3px;
  }
  .event-con-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
  }
</style>
